import { FC } from 'react'
import { MaintenanceMode, MaintenanceModeType } from './MaintenanceMode'

export const Controls: FC & MaintenanceModeType = (): JSX.Element => <></>

Controls.MaintenanceMode = MaintenanceMode
